/** Named user intents. Successful business outcomes remain in AnalyticsEvent. */
export const CONTROL_ACTIONS = [
    "salary_filter_submitted",
    "salary_bound_edited",
    "salary_unstated_toggled",
    "salary_apply_clicked",
    "salary_filter_cleared",
    "keyword_match_details_opened",
    "guide_opened",
    "pagination_previous_clicked",
    "pagination_next_clicked",
    "notification_sound_toggled",
    "notification_sound_previewed",
    "notification_action_clicked",
    "job_location_edited",
    "job_location_selected",
    "job_location_search_clicked",
    "job_location_search_submitted",
    "resume_file_picker_opened",
    "envoy_chip_added",
    "envoy_chip_removed",
    "resume_chip_added",
    "resume_chip_removed",
    "resume_file_dropped",
    "support_message_sent",
    "support_message_failed",
    "dialog_dismissed",
    "notification_dismissed",
    "resume_section_reordered",
    "resume_role_reordered",
    "resume_bullet_reordered",
    "account_delete_cancelled",
    "account_delete_confirm_clicked",
    "account_delete_opened",
    "account_export_clicked",
    "account_export_download_clicked",
    "account_menu_toggled",
    "account_name_edited",
    "account_preferences_save_clicked",
    "account_test_email_picked",
    "account_test_email_sent",
    "account_timezone_changed",
    "application_detail_back_clicked",
    "application_details_toggled",
    "application_form_open_clicked",
    "application_list_retry_clicked",
    "application_more_toggled",
    "application_selected",
    "application_source_clicked",
    "application_tab_selected",
    "billing_interval_selected",
    "billing_portal_clicked",
    "company_jobs_clicked",
    "dialog_close_clicked",
    "email_choices_save_clicked",
    "email_unsubscribe_all_clicked",
    "email_unsubscribe_undone",
    "envoy_active_toggled",
    "envoy_area_cancelled",
    "envoy_area_city_edited",
    "envoy_area_city_selected",
    "envoy_area_distance_selected",
    "envoy_area_edit_clicked",
    "envoy_area_save_clicked",
    "envoy_area_submitted",
    "envoy_chip_edited",
    "envoy_chip_remove_clicked",
    "envoy_configure_clicked",
    "envoy_currency_changed",
    "envoy_edit_cancelled",
    "envoy_form_submitted",
    "envoy_instructions_edited",
    "envoy_language_any_selected",
    "envoy_language_toggled",
    "envoy_model_selected",
    "envoy_more_filters_toggled",
    "envoy_order_selected",
    "envoy_pause_cancelled",
    "envoy_pause_confirm_clicked",
    "envoy_pause_opened",
    "envoy_pause_reason_selected",
    "envoy_pay_edited",
    "envoy_posted_window_selected",
    "envoy_resume_clicked",
    "envoy_save_clicked",
    "envoy_search_widen_clicked",
    "envoy_seniority_toggled",
    "envoy_suggestion_selected",
    "envoy_unstated_pay_toggled",
    "envoy_work_setting_toggled",
    "error_recovery_clicked",
    "extension_install_clicked",
    "extension_install_dismissed",
    "extension_prompt_preference_changed",
    "filter_menu_toggled",
    "filter_option_selected",
    "filter_panel_toggled",
    "history_csv_export_clicked",
    "history_external_link_clicked",
    "history_page_next_clicked",
    "history_page_previous_clicked",
    "history_period_selected",
    "history_search_edited",
    "history_status_selected",
    "history_summary_toggled",
    "job_distance_credit_clicked",
    "job_distance_selected",
    "job_filters_cleared",
    "job_location_cleared",
    "job_page_next_clicked",
    "job_page_previous_clicked",
    "job_posted_window_selected",
    "job_search_cleared",
    "job_search_edited",
    "job_sort_selected",
    "job_status_selected",
    "job_work_setting_toggled",
    "join_dialog_closed",
    "join_dialog_opened",
    "join_signin_clicked",
    "join_signup_clicked",
    "legal_section_opened",
    "mark_sent_cancelled",
    "mark_sent_confirm_clicked",
    "mark_sent_opened",
    "model_upgrade_clicked",
    "model_upgrade_dismissed",
    "navigation_clicked",
    "notice_subscription_toggled",
    "opening_families_expanded",
    "opening_filters_cleared",
    "opening_family_toggled",
    "opening_page_more_clicked",
    "opening_scope_selected",
    "opening_sort_selected",
    "opening_unread_toggled",
    "overview_tile_clicked",
    "pack_browse_clicked",
    "pack_select_clicked",
    "plan_select_clicked",
    "plan_upgrade_clicked",
    "posting_company_search_clicked",
    "posting_drawer_closed",
    "posting_drawer_opened",
    "posting_full_page_clicked",
    "posting_queue_blocked",
    "posting_queue_clicked",
    "posting_retry_clicked",
    "posting_source_open_clicked",
    "posting_unqueue_clicked",
    "preview_fill_mode_selected",
    "preview_resume_toggled",
    "pricing_faq_link_clicked",
    "pricing_faq_toggled",
    "public_posted_window_selected",
    "public_search_edited",
    "public_work_setting_toggled",
    "resume_blank_start_clicked",
    "resume_bullet_add_clicked",
    "resume_bullet_move_requested",
    "resume_bullet_remove_clicked",
    "resume_certification_add_clicked",
    "resume_certification_remove_clicked",
    "resume_chip_edited",
    "resume_chip_remove_clicked",
    "resume_education_add_clicked",
    "resume_education_remove_clicked",
    "resume_field_edited",
    "resume_file_removed",
    "resume_file_selected",
    "resume_form_submitted",
    "resume_format_selected",
    "resume_import_back_clicked",
    "resume_import_cancelled",
    "resume_import_closed",
    "resume_import_contact_edited",
    "resume_import_continue_clicked",
    "resume_import_identity_confirm_clicked",
    "resume_import_mode_toggled",
    "resume_import_retry_clicked",
    "resume_import_save_clicked",
    "resume_import_start_clicked",
    "resume_issue_dropped",
    "resume_issue_kept",
    "resume_issue_opened",
    "resume_leave_confirmed",
    "resume_leave_kept",
    "resume_manual_edit_clicked",
    "resume_paste_edited",
    "resume_pdf_download_clicked",
    "resume_review_submitted",
    "resume_role_add_clicked",
    "resume_role_move_requested",
    "resume_role_remove_clicked",
    "resume_save_clicked",
    "resume_section_move_requested",
    "resume_tab_selected",
    "resume_upload_opened",
    "sent_resume_view_selected",
    "sign_in_retry_clicked",
    "sign_out_clicked",
    "skip_cancelled",
    "skip_confirm_clicked",
    "skip_opened",
    "skip_reason_selected",
    "support_email_clicked",
    "support_field_edited",
    "support_form_submitted",
    "support_new_message_clicked",
    "support_send_clicked",
    "tailor_limit_banner_dismissed",
    "tailored_delete_cancelled",
    "tailored_delete_confirmed",
    "tailored_delete_opened",
    "tailored_list_retry_clicked",
    "tailored_more_toggled",
    "tailored_pdf_open_clicked",
    "tailored_pdf_download_clicked",
    "theme_selected",
    "work_answers_edited",
    "work_answers_save_clicked",
    "gate_continue_clicked",
    "gate_sheet_closed",
    "gate_signin_clicked",
    "posting_save_clicked",
    "posting_unsave_clicked",
    "posting_tailor_clicked",
    "tailor_cancelled",
    "tailor_confirmed",
    "tailor_instructions_edited",
    "tailor_keyword_toggled",
    "tailor_skill_toggled",
    "saved_remove_clicked",
    "saved_list_new_clicked",
    "saved_list_selected",
    "saved_list_rename_clicked",
    "saved_list_delete_clicked",
    "saved_list_name_edited",
    "saved_list_name_saved",
    "saved_list_delete_confirmed",
    "saved_list_unsave_toggled",
    "saved_dialog_cancelled",
    "saved_status_filter_selected",
    "saved_mark_applied_clicked",
    "saved_skip_clicked",
    "saved_skip_confirmed",
    "saved_reopen_clicked",
    "saved_lists_menu_toggled",
    "envoy_turn_on_clicked",
    "envoy_retry_clicked",
    "envoy_preferences_full_toggled",
    "envoy_find_toggled",
    "envoy_auto_toggled",
    "envoy_auto_confirmed",
    "envoy_auto_cancelled",
    "tailors_pill_clicked",
    "envoy_chip_clicked",
    "upgrade_plan_clicked",
    "upgrade_pack_clicked",
    "signup_terms_toggled",
    "terms_prompt_toggled",
    "terms_prompt_accepted",
    "terms_prompt_reload_clicked",
    "analytics_banner_allowed",
    "analytics_banner_declined",
    "analytics_consent_toggled",
    "analytics_choice_opened",
    "tool_check_clicked",
    "tool_check_run",
    "tool_tailor_pressed",
    "tool_tailor_job_edited",
    "tool_tailor_submitted",
    "tool_tailor_continue_clicked",
    "tool_tailor_back_clicked",
    "tool_account_created",
    "tool_tailor_done",
] as const;

export type ControlAction = (typeof CONTROL_ACTIONS)[number];
